import Vue from 'vue'

import elTableDirective from './el-table';
Vue.use(elTableDirective)
